import { Injectable } from '@angular/core';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { AppConfig } from '../../shared/config/app-config';
import { StringHelper } from '../helpers/strings.helper';
import { Merchant, OfflineCustomer, OfflinePaymentQueryParams, OfflinePaymentResponse, OfflineTransactionModel } from '../../shared/models/offline.model';
import * as moment from 'moment';
import { Subject } from 'rxjs';

@Injectable()
export class OfflineService {
	private isMobileSearch: boolean;
	private _destroyOfflineModal = new Subject<any>();
	private currentTransTab = 0;
	_destroyOfflineModal$ = this._destroyOfflineModal.asObservable();

	private _reloadTable = new Subject<any>();
	_reloadTable$ = this._reloadTable.asObservable();

	private _reloadPayCodeTable = new Subject<any>();
	_reloadPayCodeTable$ = this._reloadPayCodeTable.asObservable();

	private offlinePaymentQueryParams: OfflinePaymentQueryParams = null;

	private offlinePaymentPayCodeQueryParams: OfflinePaymentQueryParams = null;

	constructor(private apiClientHelper: ApiClientHelper,
		public config: AppConfig) {
		this.initializeOfflineParam();
	}

	setCurrentTransTab(index) {
		this.currentTransTab = index;
	}

	getCurrentTransTab() {
		return this.currentTransTab;
	}

	private initializeOfflineParam() {
		this.offlinePaymentQueryParams = OfflineService.fillParam();
		this.offlinePaymentPayCodeQueryParams = OfflineService.fillParam();
	}

	private static fillParam() {
		return {
			pageSize: 10,
			pageNumber: 1,
			reference: '',
			status: '',
			startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
			endDate: moment().subtract(0, 'days').format('YYYY-MM-DD')
		}
	}

	setMobileSearch(isMobile) {
		this.isMobileSearch = isMobile;
	}

	destroyModal(value?) {
		this._destroyOfflineModal.next(value ? value : 'close');
	}

	getMobileSearch() {
		return this.isMobileSearch;
	}

	resetParams() {
		// this.setOfflineSearchIndex(0);
		// this.offlinePaymentQueryParams = null;
		this.offlinePaymentQueryParams = { ...OfflineService.fillParam() };
	}

	resetPayCodeParams() {
		// this.setOfflineSearchIndex(0);
		// this.offlinePaymentPayCodeQueryParams = null;
		this.offlinePaymentPayCodeQueryParams = { ...OfflineService.fillParam() };
	}

	setOfflinePaymentQueryParams(params) {
		this.offlinePaymentQueryParams = params;
	}

	setOfflinePayCodePaymentQueryParams(params) {
		this.offlinePaymentPayCodeQueryParams = params;
	}

	reloadTables() {
		this._reloadTable.next(true);
	}

	reloadPayCodeTables() {
		this._reloadPayCodeTable.next(true);
	}

	getOfflinePaymentQueryParams() {
		return this.offlinePaymentQueryParams;
	}

	getOfflinePayCodePaymentQueryParams() {
		return this.offlinePaymentPayCodeQueryParams;
	}

	getMerchants(): Promise<Merchant[]> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/offline-payment/merchants`;
		return this.apiClientHelper.getForPromise(url);
	}

	verifyCustomer(params): Promise<OfflineCustomer> {
		params = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/offline-payment/deposit/customer-information?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	makePayment(params): Promise<OfflinePaymentResponse> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/offline-payment/deposit/payment`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	verifyPayCode(params): Promise<OfflineCustomer> {
		params = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/offline-payment/pay-code/verify?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	debitPayCode(params): Promise<OfflinePaymentResponse> {
		const url = this.config.MONIEPOINT_HOST + `/api/v1/offline-payment/pay-code/debit`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	getDepositTransactions(params): Promise<OfflineTransactionModel> {
		params = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/transactions/agents/offline-deposits?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getWithDrawerTransactions(params): Promise<OfflineTransactionModel> {
		params = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/transactions/agents/offline-withdrawals?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getDepositDetails(params: string): Promise<any> {
		const url = this.config.MONIEPOINT_OFFLINE_PAYMENT + `/api/v1/offline-payment/deposit/details/${params}`;
		return this.apiClientHelper.getForPromise(url);
	}
	getWithdrawalDetails(params: string): Promise<any> {
		const url = this.config.MONIEPOINT_OFFLINE_PAYMENT + `/api/v1/offline-payment/pay-code/details/${params}`;
		return this.apiClientHelper.getForPromise(url);
	}
}
